<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Empleados</h1>
    <p class="text-lg md:text-xl">
      Consulta, añade, edita y elimina los empleados.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="flex flex-col gap-10">
    <div class="flex flex-col md:flex-row gap-5">
      <button
        mat-raised-button
        aria-hidden="false"
        aria-label="Actualizar"
        (click)="reload()"
        [disabled]="loading"
      >
        <mat-icon>refresh</mat-icon>
        <span>Actualizar</span>
      </button>
      <button
        mat-flat-button
        aria-hidden="false"
        aria-label="Crear"
        (click)="create()"
      >
        <mat-icon>add</mat-icon>
        <span>Crear</span>
      </button>
    </div>

    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="tableData"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="displayName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por nombre"
          >
            Nombre
          </th>
          <td mat-cell *matCellDef="let employee">
            {{ employee.displayName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="username">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por usuario"
          >
            Usuario
          </th>
          <td mat-cell *matCellDef="let employee">
            {{ employee.username }}
          </td>
        </ng-container>
        <ng-container matColumnDef="email">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por correo electrónico"
          >
            Correo electrónico
          </th>
          <td mat-cell *matCellDef="let employee">
            {{ employee.email }}
          </td>
        </ng-container>
        <ng-container matColumnDef="role.displayName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por perfil"
          >
            Perfil
          </th>
          <td mat-cell *matCellDef="let employee">
            {{ employee.role.displayName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="disabled">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por estado"
          >
            Activo
          </th>
          <td mat-cell *matCellDef="let employee">
            <mat-slide-toggle
              [checked]="!employee.disabled"
              (change)="toggleStatus(employee, $event.checked)"
            >
            </mat-slide-toggle>
          </td>
        </ng-container>
        <ng-container matColumnDef="updatedAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha de modificación"
          >
            Modificado
          </th>
          <td mat-cell *matCellDef="let employee" class="text-nowrap">
            {{ employee.updatedAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha de creación"
          >
            Creado
          </th>
          <td mat-cell *matCellDef="let employee" class="text-nowrap">
            {{ employee.createdAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let employee">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              aria-label="Acciones"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="update(employee)">
                <mat-icon>edit</mat-icon>
                <span>Editar</span>
              </button>
              <button mat-menu-item (click)="updatePassword(employee)">
                <mat-icon>lock_reset</mat-icon>
                <span>Cambiar contraseña</span>
              </button>
              <button mat-menu-item (click)="delete(employee)">
                <mat-icon>delete</mat-icon>
                <span>Eliminar</span>
              </button>
            </mat-menu>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="9" class="mat-cell py-5 text-gray-500 text-center">
            No hay empleados
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecciona la página"
    >
    </mat-paginator>
  </section>
</div>
